<template>
  <div>
    <generic-container
      :title="$t('prototype list')"
      icon="robot"
      :searchable="true"
      v-on:filter="filter"
      :header_buttons="header_buttons"
      :show_refresh="true"
      @refresh="getData"
      :show_plus="false"
    >
      <div class="ui six link cards">
        <div
          class="card"
          v-for="mdle in shown_prototypes"
          v-bind:key="mdle.uuid"
          v-on:click="go_to_prototype(mdle)"
          style="margin: 10px 10px !important"
        >
          <div class="content">
            <h3 class="ui icon header" style="margin-bottom:0">
              <img
                src="/images/icons/generic_prototype.jpeg"
                class="ui image"
              />
              <div class="content" style="margin-top:8px">
                {{ mdle.name }}
              </div>
            </h3>
          </div>
        </div>
      </div>
      <!-- <pre>{{ this.all_prototypes }}</pre> -->
      <!-- <div class="ui two cards">
        <div
          class="card"
          v-for="(item, index) in shown_prototypes"
          v-bind:key="index"
        >
          <div class="content">
            <img
              class="right floated mini ui image"
              src="/images/icons/industrial_robot.png"
            />
            <div class="header">{{ item.name }}</div>
            <div class="meta"></div>
          </div>
        </div>
      </div> -->
    </generic-container>
    <template v-for="(mdl, index) in prototype_modals">
      <component
        :is="mdl"
        :key="index"
        :prototype_in="selected_prototype"
        @destroy="destroy"
        @succedded="succedded"
        @deleted="deleted"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api } from "@/utils";
import { cloneDeep } from "lodash";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";

// @ is an alias to /src
export default {
  name: "PrototypeIndex",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      shown_prototypes: [],
      all_prototypes: [],
      selected_prototype: undefined,
      prototype_modals: [],
      header_buttons: [
        {
          icon: "orange cubes",
          tooltip: this.$t("prototype composer"),
          click: this.compose,
        },
      ],
    };
  },
  computed: {},
  methods: {
    compose() {
      this.$router.push({ name: "PrototypeComposer" });
    },
    succedded(p) {
      let idx = this.all_prototypes.findIndex((r) => r.uuid == p.uuid);
      if (idx >= 0) this.all_prototypes.splice(idx, 1, p);
      else this.all_prototypes.push(p);
      this.destroy();
    },
    deleted(p) {
      let idx = this.all_prototypes.findIndex((r) => r.uuid == p.uuid);
      if (idx >= 0) this.all_prototypes.splice(idx, 1);
      this.destroy();
    },
    destroy() {
      setTimeout(() => {
        this.prototype_modals = [];
        this.selected_prototype = undefined;
      }, 300);
    },
    filter(filter) {
      if (filter == "") this.shown_prototypes = cloneDeep(this.all_prototypes);
      else
        this.shown_prototypes = this.all_prototypes.filter(
          (n) =>
            n.setup.general.name.toUpperCase().includes(filter.toUpperCase()) ||
            n.setup.general.project
              .toUpperCase()
              .includes(filter.toUpperCase()) ||
            n.setup.general.description
              .toUpperCase()
              .includes(filter.toUpperCase()),
        );
    },
    show_prototype(prototype) {
      this.$router.push({
        name: "PrototypeViewer",
        query: { i: prototype.uuid },
      });
    },
    getData() {
      let vm = this;
      local_api(vm, "post", "/prototype/do-get-available")
        .then((prototypes) => {
          this.all_prototypes = prototypes;
          this.shown_prototypes = cloneDeep(prototypes);
        })
        .catch((err) => {
          vm.$alertify.error(JSON.stringify(err, null, 2));
        });
    },
    go_to_prototype(mdle) {
      this.$router.push({
        name: "PrototypeViewer",
        query: { i: mdle.uuid },
      });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {},
};
</script>
